import "../enrollToRetailerFinance/retailerFinance.css";
import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { Grid, Box, Button, LoadingOverlay } from "@mantine/core";
import { Heading } from "../heading/heading";
import { bankListType, popupType } from "../../../types/types";
import { getMetadata, submitBankNameAdmin } from "../../../services/bankingService";
import { useAuth } from "../../../providers/AuthProvider";
import { GenericPopUp } from "../../popup/genericPopUp";
import { PaymentMethodTilesAdmin } from "./retailerHelperAdmin/PaymentMethodTilesAdmin";
import { validateWithOtp } from "../../../stateManagement/actions/validateOtpPopupActions";
import { manageUpdateAccessObj } from "../../../features/manageUpdateAccess/manageUpdateAccessTypes";

export function RetailerFinanceAdmin() {
  const authContext = useAuth();
  const[bankList, setbankList] = useState<bankListType[]>([])
  const[metadata, setMetaData] = useState<any>([]);

  const fetchBankList = useCallback ( async () => {
    setLoaderShowOnCreateAccount(true);
    const metaDataResponse = await getMetadata();
    const bankListResponse = metaDataResponse.features.filter( (j:any) => (j.domainName === "clientconfig" && j.domainType === "bankList"));  
   
   
    const domainBankList = bankListResponse[0]?.domainValues;
    let newList : bankListType[] = [];
    newList = domainBankList;
    setLoaderShowOnCreateAccount(false);
    await setbankList(newList);
    return newList;
  
  },[authContext])

   const enrolledBanksApiCall = useCallback ( async() =>{
      let enrolledBanksResponse = await getMetadata();
      const metaDataResult = enrolledBanksResponse.features.filter( (j:any) => (j.domainName === "transactionFilter" && j.domainType === "filter"));
      const domainValues = metaDataResult[0].domainValues;
      
      return domainValues;
      
 },[ authContext])

  useEffect(() => {
    const method = async () => {
    await fetchBankList();
    setLoaderShowOnCreateAccount(true);
    const metaDataResponseList = await enrolledBanksApiCall();
    setMetaData(metaDataResponseList);
    setLoaderShowOnCreateAccount(false);
  }
  method();
    
    },[ fetchBankList, enrolledBanksApiCall]);

  const [loaderShowOnCreateAccount, setLoaderShowOnCreateAccount] = useState<boolean>(false);
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage,setGenericMessage] = useState("");


  let requestBody = {
    lob: JSON.parse(localStorage.authContext).user.lob,
    domainName :"transactionFilter",
    domainType :"filter",
    domainValues : metadata
  };

  const openPopup = (message:string, type:popupType)=>{
    setPopupType(type)
    setGenericMessage(message)
    setOpenGenericModal(true)
  }

  const submitForm = async () => {
    setLoaderShowOnCreateAccount(true);
requestBody.domainValues=metadata;

      try {
        //  await submitBankNameAdmin(
        //   requestBody,
        // );
        
        //   openPopup("Permission updated", "Success");

        // setLoaderShowOnCreateAccount(false);

        const api =  `/metadata/transactionFilter?name=filter`;
        validateWithOtp((verifiedUser?: manageUpdateAccessObj,verifyResponse?: any) => {
          try{
            if (verifyResponse.status === 201 || verifyResponse.status === 200) {
              openPopup("Permission updated", "Success");
              setLoaderShowOnCreateAccount(false);
            }  else {
              setLoaderShowOnCreateAccount(false);
              openPopup("Something went wrong!", "Error");
              throw new Error();
            }
          }catch(error){
            setLoaderShowOnCreateAccount(false);
            openPopup("Something went wrong!", "Error");
          }
        },["demo","prod","prod-egtm"],"admin",api,requestBody,"PUT");
      } catch (e: any) {
        setLoaderShowOnCreateAccount(false);
        if(e?.data?.statusDesc){
        openPopup(e?.data?.statusDesc,"Error")
        }else{
          openPopup(e?.data?.message,"Error")
        }
      }
    setLoaderShowOnCreateAccount(false);
  };
  
  return (
    <div className="app-container">
      {loaderShowOnCreateAccount && (
        <LoadingOverlay
          visible={loaderShowOnCreateAccount}
          style={{ position: "fixed" }}
        />
      )}

    <GenericPopUp message={genericMessage}
      type={popupType}
      openGenericModal={openGenericModal}
      setOpenGenericModal={setOpenGenericModal} />

      <Box className="mainBox">
        <Box className="headingAndTilesContainer">
          <Heading mainHeading="Payment Blocking" />
          <Box className="tiles">
            <Grid>
              {bankList
                .map((obj) => (
                  <PaymentMethodTilesAdmin
                    id={obj.id}
                    name={obj.name}
                    image={obj.image}
                    metaDataBankList={metadata}
                    setMetaData={setMetaData}
                  />
                ))}
            </Grid>
          </Box>
        </Box>
        <Box
          sx={() => ({
            textAlign: "center",
            marginBottom: "40px",
            marginTop: "50px",
          })}
        >
          <Button style={{ backgroundColor: "#02BBd5" }} onClick={submitForm}>
            Submit
          </Button>
        </Box>
      </Box>
    </div>
  );
}


